var React = require('react');

function IconSuccessInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"35.5006","cy":"36.1002","r":"35.4166","fill":"#23C865","key":0}),React.createElement("path",{"d":"M22.9573 40.0775L33.2871 51.1452L50.9954 23.1071","stroke":"white","strokeWidth":"9","strokeLinecap":"round","key":1})]);
}

IconSuccessInline.defaultProps = {"width":"71","height":"72","viewBox":"0 0 71 72","fill":"none"};

module.exports = IconSuccessInline;

IconSuccessInline.default = IconSuccessInline;
